// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/chunks/" + chunkId + "." + {"400":"a12b30c6","401":"862e58f9","648":"e7ca99ea","735":"a12b30c6","937":"b902de54"}[chunkId] + ".min.css";
};